// Small menus that open upward from the toolbar. Plain elements (no portal) so they work inside the pop-out window.
import { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';

export function MenuWrap({ open, setOpen, anchor, children, align = 'left', tid, wide }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const doc = ref.current?.ownerDocument || document;
    const down = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const key = (e) => { if (e.key === 'Escape') setOpen(false); };
    doc.addEventListener('pointerdown', down);
    doc.addEventListener('keydown', key);
    return () => { doc.removeEventListener('pointerdown', down); doc.removeEventListener('keydown', key); };
  }, [open, setOpen]);
  return (
    <div ref={ref} className="relative flex">
      {anchor}
      {open && (
        <div className={`absolute bottom-full z-50 mb-2 max-h-[60vh] ${wide ? 'w-80' : 'w-72'} overflow-y-auto rounded-xl border border-white/10 bg-[#0D1B2A] p-1.5 text-left shadow-2xl ${align === 'right' ? 'right-0' : 'left-0'}`}
          data-testid={tid}>
          {children}
        </div>
      )}
    </div>
  );
}

export const MenuLabel = ({ children }) => (
  <p className="px-2.5 pb-1 pt-2 text-[10px] font-bold uppercase tracking-wider text-slate-400 first:pt-1">{children}</p>
);

export function MenuItem({ checked, onClick, children, tid, danger, disabled }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} data-testid={tid}
      {...(checked !== undefined ? { role: 'menuitemcheckbox', 'aria-checked': !!checked } : {})}
      className={`flex w-full items-center gap-2 rounded-lg px-2.5 py-2 text-left text-[13px] transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-40 ${danger ? 'text-red-400 hover:bg-red-500/15' : 'text-slate-200 hover:bg-white/10 hover:text-white'}`}>
      <span className="flex h-4 w-4 shrink-0 items-center justify-center">{checked && <Check className="h-4 w-4 text-[#7FA8D6]" />}</span>
      <span className="min-w-0 flex-1 truncate">{children}</span>
    </button>
  );
}

export const MenuDivider = () => <div className="my-1 border-t border-white/10" />;
